import React, { FC, ReactElement } from 'react';
import './VacationType.scss';
import { VacationType as IVacationType } from './Interfaces/VacationType';
import { Tile, Heading } from 'mvw-component-library';
import { DESTINATION_REACT_APP_BASE_URL } from '../../Utility/constants';

interface IProps {
  vacationTypesContent?: IVacationType[] | [] | undefined;
}
const VacationType: FC<IProps> = ({ vacationTypesContent }: IProps): ReactElement => {
  const firstNineVacationTypes = vacationTypesContent?.slice(0, 9);
  const vacationTypeTitle = 'BROWSE BY VACATION TYPE';
  return (
    <div className="vacation-type-container rc-row">
      {/* <div role="heading" aria-level={1}> */}
      <Heading
        headerTag="h1"
        ariaLavel={1}
        areaLabel={vacationTypeTitle}
        headerLabel={vacationTypeTitle}
        classNames="nav-header-class"
      />
      {/* </div> */}
      <div className="rc-row ">
        {firstNineVacationTypes ? (
          firstNineVacationTypes.map((vacationType) => {
            return (
              <div
                key={vacationType.vacationTypeId}
                className="vacation-tile rc-col-lg-1 rc-col-md-2 rc-col-sm-1 rc-col-6"
              >
                <Tile
                  image={vacationType.vacationTypeImage}
                  label={vacationType.vacationTypeTitle}
                  linkUrl={`${DESTINATION_REACT_APP_BASE_URL}${vacationType.vacationTypeId}`} //link structure to be changed
                  aspectRatio={16 / 9}
                  areaLabel={`browse by vacation type-${vacationType.vacationTypeTitle}`}
                />
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default VacationType;
